import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

function NuevoRegistroAgenda(){

//Hooks

const[color, setColor] = useState('')
const[title, setTitle] = useState('')
const[place, setPlace] = useState('')
const[start, setStart] = useState('')
const[description, setDescription] = useState('')


function agregarRegistro(){
  var registros = {
    title: title,
    place: place,
    start: start,
    color: color,
    description: description
  }
  console.log(registros);  
  axios.post("http://localhost:4000/api/Agenda/", registros )
  .then( res => {
    alert(res.registros)
  })
  
};

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="mt-5">
            <h3 className="title">
              Nuevo registro de la Agenda del Secretario
            </h3>
            <hr className="hr-gob" />
          </div>
        </div>

        <form onSubmit={agregarRegistro} >
          <div className="row mb-3">
            <div className="card border">
              <div className="card-body">
                <div className="row">
                  <input
                    type="text"
                    className="form-control"
                    value={color}      
                    onChange={(e) => {setColor(e.target.value)}}
                  ></input>

                  <div className="col-md-4">
                    <div className="mb-3">
                      <label htmlfor="title" className="form-label">
                        Título
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={title}
                        onChange={(e) => {setTitle(e.target.value)}}
                      ></input>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="mb-3">
                      <label htmlfor="place" className="form-label">
                        Lugar
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name=""
                        value={place}
                        onChange={(e) => {setPlace(e.target.value)}}
                      ></input>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="mb-3">
                      <label htmlfor="start" className="form-label">
                        Fecha
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        value={start}
                        onChange={(e) => {setStart(e.target.value)}}
                      ></input>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="mb-3">
                      <label htmlfor="description" className="form-label">
                        Enlace Twitter
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name=""
                        value={description}
                        onChange={(e) => {setDescription(e.target.value)}}                        
                      ></input>
                    </div>
                  </div>
                </div>
                <hr className="hr-gob" />
                <div className="row">
                  <div className="col-md-6">
                    <Link to="/RegistrosAgenda">
                      <button className="btn btn-primary float-start">
                        Regresar
                      </button>
                    </Link>
                  </div>
                  <div className="col-md-6">
                    <button type="submit" className="btn btn-success float-end">
                      Guardar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default NuevoRegistroAgenda